import React, { Component } from 'react';

class Error extends Component {
  render() {
    return (
      <div>
        Sorry, something's gone wrong.
        Please <a style={ { color: "white", textDecoration: "underline" } } href="/contact-us">contact us</a> so
        we can look into this
      </div>
    );
  }
}

export default Error;



// WEBPACK FOOTER //
// ./src/components/elearning/error.jsx